import { useNavigate } from "react-router-dom";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../presentation/hooks/store-hooks";
import { useExtracaoApi, useProjetosApi } from "../../../infra/geo-veles";
import { useUIService } from "../../ui";
import { useCallback } from "react";
import {
  addListaCBOFilterState,
  removeListaCBOFilterState,
  addClasseSocialFilterState,
  addContatoFilterState,
  addEscolaridadeFilterState,
  addEstadoCivilFilterState,
  addListaCEPFilterState,
  addListaDeduplicacaoFilterState,
  addLocalizacaoFilterState,
  addProfissaoFilterState,
  addPurgeListaCEPFilterState,
  addPurgeLocalizacaoFilterState,
  addScoreVelesFilterState,
  addSexoFilterState,
  IActionTypes,
  IActiveSection,
  removeCBOFilterState,
  removeClasseSocialFilterState,
  removeContatoFilterState,
  removeEscolaridadeFilterState,
  removeEstadoCivilFilterState,
  removeListaCEPFilterState,
  removeListaDeduplicacaoFilterState,
  removeLocalizacaoFilterState,
  removeProfissaoFilterState,
  removePurgeListaCEPFilterState,
  removePurgeLocalizacaoFilterState,
  removeScoreVelesFilterState,
  removeSexoFilterState,
  resetCreateExtracaoFormState,
  resetCreateProjetoFormState,
  resetDataNascimentoFilterState,
  resetEditProjetoFormState,
  resetFiltrosSelecionadosState,
  resetGeolocalizacaoFilterState,
  resetIdadeFilterState,
  resetProjetoAbertoState,
  resetProjetoActionState,
  resetProjetoFiltroAtivoState,
  resetProjetoListFiltrosAtivoState,
  resetProjetoListFiltrosInclusaoEndState,
  resetProjetoListFiltrosInclusaoStartState,
  resetProjetoListFiltrosSearchTermState,
  resetProjetoListFiltrosState,
  resetProjetoListFiltrosUsuarioState,
  resetProjetoListFiltrosLoginUsuarioState,
  resetRecorteExtracaoState,
  resetRendaAnualFilterState,
  resetRendaMensalFilterState,
  setActiveDetailsSectionState,
  setCreateExtracaoFormErrorsState,
  setCreateExtracaoFormNomeState,
  setCreateExtracaoFormQuantidadeState,
  setCreateExtracaoFormTouchedState,
  setCreateProjetoFormErrorsState,
  setCreateProjetoFormIdClienteState,
  setCreateProjetoFormIdUsuarioState,
  setCreateProjetoFormNomeState,
  setCreateProjetoFormTouchedState,
  setEditProjetoFormAtivoState,
  setEditProjetoFormErrorsState,
  setEditProjetoFormIdVelesGeoProjetoState,
  setEditProjetoFormNomeState,
  setEditProjetoFormTouchedState,
  setGeolocalizacaoFilterRadiusState,
  setGeolocalizacaoFilterState,
  setGeolocalizacaoRadiusState,
  setMaxDataNascimentoFilterState,
  setMaxIdadeFilterState,
  setMaxRendaAnualFilterState,
  setMaxRendaMensalFilterState,
  setMinDataNascimentoFilterState,
  setMinIdadeFilterState,
  setMinRendaAnualFilterState,
  setMinRendaMensalFilterState,
  setOpenExportTypeState,
  setProjetoAbertoState,
  setProjetoActionState,
  setProjetoActiveSectionState,
  setProjetoFiltroAtivoState,
  setProjetoLimitState,
  setProjetoListFiltrosAtivoState,
  setProjetoListFiltrosInclusaoEndState,
  setProjetoListFiltrosInclusaoStartState,
  setProjetoListFiltrosSearchTermState,
  setProjetoListFiltrosUsuarioState,
  setProjetoListFiltrosLoginUsuarioState,
  setProjetoPageState,
  setProjetosPaginationState,
  setProjetosState,
  setRelatorioProjetoState,
  setSelectedGeolocalizacaoState,
  validateCreateExtracaoForm,
  validateCreateProjetoForm,
  validateEditProjetoForm,
  validateDuplicateProjetoForm,
  resetRelatorioProjetoState,
  setDuplicateProjetoFormIdVelesGeoProjetoState,
  setDuplicateProjetoFormErrorsState,
  setDuplicateProjetoFormNomeState,
  resetDuplicateProjetoFormState,
  setOpenFormDuplicateProjetoState,
  setOpenCreateProjetoFormState,
  setOpenEditProjetoFormState,
  addSituacaoCadastralFilterState,
  removeSituacaoCadastralFilterState,
  setProjetoListFiltrosClienteState,
  resetProjetoListFiltrosClienteState,
  addListaCidadesFilterState,
  removeListaCidadesFilterState,
  addPurgeListaCidadesFilterState,
  removePurgeListaCidadesFilterState,
  addCBOFilterState,
} from "../../../application/states/geo-veles";
import { store } from "../../../application/states/store";
import {
  IAcesso,
  IClasseSocial,
  IContato,
  IEstadoCivil,
  IGeolocalizacao,
  ILocalizacao,
  IOcupacao,
  IProdutosEnum,
  IScoreVeles,
  ISexo,
  ISituacaoCadastral,
} from "../../../application/models";
import { IEscolaridade } from "../../../application/models/geo-veles/IEscolaridade";
import { onlyNumbers, verificarIdade } from "../../../utils";
import { useNavigationService } from "../../navigation";
import { setTravaConsumoState } from "../../../application/states/geo-veles/trava_consumo";
import { setCurrentAccessState } from "../../../application/states/user";
import { useUserApi } from "../../../infra/user";
import { v4 as uuidv4 } from "uuid";
import { IListaCbo } from "../../../application/models/geo-veles/IListaCbo";
import { clearSelectedListasCbo, selectListaCbo } from "../../../application/states/geo-veles/lista-cbo";
export const useProjetosService = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  // States
  const { recorteExtracao } = useAppSelector((state) => state.recorteExtracao);
  const {
    createProjetoForm,
    editProjetoForm,
    projetosPagination,
    filtrosSelecionados,
    projetoAberto,
    createExtracaoForm,
    relatorioProjeto,
    projetoListFiltros,
    duplicateProjetoForm,
    projetos,
    projetosTotal,
  } = useAppSelector((state) => state.projetos);

  const travaConsumo = useAppSelector((state) => state.travaConsumo);
  const { currentUser, access } = useAppSelector((state) => state.user);

  // API
  const {
    createProjetoApi,
    getProjetosApi,
    updateFiltrosProjetoApi,
    getProjetoByIdApi,
    updateProjetoNomeAndAtivoApi,
    getTravaConsumoApi,
    duplicateProjetoApi,
    verifyNomeProjetoExistsApi,
  } = useProjetosApi();
  const { createExtracaoApi, verifyExtracoByNomeApi } = useExtracaoApi();
  const { verifyAccessProductApi } = useUserApi();
  // Service
  const { setAlert, setLoading } = useUIService();
  const { navigateTo } = useNavigationService();
  //const {resetRecorteExtracao} = useRecortesExtracaoService()

  // Hooks
  const setProjetos = useCallback(async () => {
    if (currentUser) {
      const loadingId = Math.random().toString();
      setLoading({
        id: loadingId,
        loading: true,
        message: "Buscando projetos...",
      });

      try {
        const projetos = await getProjetosApi({
          filter: {
            idUsuario: currentUser.IdUsuario,
            cliente: projetoListFiltros.loginCliente,
            inclusaoMax: projetoListFiltros.inclusaoEnd,
            inclusaoMin: projetoListFiltros.inclusaoStart,
            searchTerm: projetoListFiltros.searchTerm,
            ativo: projetoListFiltros.ativo,
            usuario: projetoListFiltros.usuario,
            loginUsuario: projetoListFiltros.loginUsuario
          },
          pagination: {
            page: projetosPagination.page,
            pageSize: projetosPagination.limit,
          },
        });

        if (
          projetos.listasDeduplicacao &&
          projetos.listasDeduplicacao.length > 0
        ) {
          for (let i = 0; i < projetos.listasDeduplicacao.length; i++) {
            const lista = projetos.listasDeduplicacao[i];
            if (
              Number(projetos.projetos[i].Filtros?.listasDeduplicacao?.[i]) ===
              lista.IdVelesGeoListaDeduplicacao
            ) {
              projetos.projetos[i].listasDeduplicacao =
                projetos.projetos[i].listasDeduplicacao || [];
              projetos.projetos[i].listasDeduplicacao!.push(lista);
            }
          }
        }

        if (projetos.listasCEP && projetos.listasCEP.length > 0) {
          for (let i = 0; i < projetos.listasCEP.length; i++) {
            const lista = projetos.listasCEP[i];
            if (
              Number(projetos.projetos[i].Filtros?.listasCEP?.[i]) ===
              lista.IdVelesGeoListaCEP
            ) {
              projetos.projetos[i].listasCEP =
                projetos.projetos[i].listasCEP || [];
              projetos.projetos[i].listasCEP!.push(lista);
            }
            projetos.projetos[i].listasCEP =
              projetos.projetos[i].listasCEP || [];
          }
        }

        dispatch(
          setProjetosState({
            projetos: projetos.projetos,
            total: projetos.total,
          })
        );

      } catch (error: any) {
        setAlert({
          message: error.response.data.error,
          type: "error",
        });
      } finally {
        setLoading({
          id: loadingId,
          loading: false,
        });
      }
    }
  }, [
    currentUser,
    setLoading,
    projetoListFiltros,
    getProjetosApi,
    projetosPagination.page,
    projetosPagination.limit,
    dispatch,
    setAlert,
  ]);

  const setProjetosPaginaInicial = useCallback(async () => {
    if (currentUser) {
      try {
        const projetos = await getProjetosApi({
          filter: {
            idUsuario: currentUser.IdUsuario,
          },
          pagination: {
            page: 1,
            pageSize: 5,
          },
        });

        if (
          projetos.listasDeduplicacao &&
          projetos.listasDeduplicacao.length > 0
        ) {
          for (let i = 0; i < projetos.listasDeduplicacao.length; i++) {
            const lista = projetos.listasDeduplicacao[i];
            if (
              Number(projetos.projetos[i].Filtros?.listasDeduplicacao?.[i]) ===
              lista.IdVelesGeoListaDeduplicacao
            ) {
              projetos.projetos[i].listasDeduplicacao =
                projetos.projetos[i].listasDeduplicacao || [];
              projetos.projetos[i].listasDeduplicacao!.push(lista);
            }
          }
        }

        if (projetos.listasCEP && projetos.listasCEP.length > 0) {
          for (let i = 0; i < projetos.listasCEP.length; i++) {
            const lista = projetos.listasCEP[i];
            if (
              Number(projetos.projetos[i].Filtros?.listasCEP?.[i]) ===
              lista.IdVelesGeoListaCEP
            ) {
              projetos.projetos[i].listasCEP =
                projetos.projetos[i].listasCEP || [];
              projetos.projetos[i].listasCEP!.push(lista);
            }
            projetos.projetos[i].listasCEP =
              projetos.projetos[i].listasCEP || [];
          }
        }

        dispatch(
          setProjetosState({
            projetos: projetos.projetos,
            total: projetos.total,
          })
        );
      } catch (error: any) {
        setAlert({
          message: error.response.data.error,
          type: "error",
        });
      }
    }
  }, [currentUser, dispatch, setAlert]);

  const setOpenCreateProjetoForm = useCallback(
    (openForm: boolean) => {
      if (openForm) {
        if (currentUser) {
          dispatch(
            setCreateProjetoFormIdUsuarioState({
              idUsuario: currentUser.IdUsuario,
            })
          );
          dispatch(
            setCreateProjetoFormIdClienteState({
              idCliente: currentUser.IdCliente,
            })
          );
        }
        dispatch(setOpenCreateProjetoFormState(true));
      } else {
        dispatch(resetCreateProjetoFormState());
      }
    },
    [currentUser, dispatch]
  );

  const createProjeto = useCallback(async () => {
    if (currentUser) {
      const loadingId = Math.random().toString();

      try {
        const errors = validateCreateProjetoForm(createProjetoForm.fields);

        if (errors.length > 0) {
          dispatch(
            setCreateProjetoFormErrorsState({
              errors: errors,
            })
          );
          dispatch(
            setCreateProjetoFormTouchedState({
              touched: true,
            })
          );
        } else {
          const verifyNomeProjetoExists: boolean =
            await verifyNomeProjetoExistsApi({
              idUsuario: currentUser.IdUsuario,
              nome: createProjetoForm.fields.nome.trim(),
            });

          if (!verifyNomeProjetoExists) {
            setAlert({
              message: "Já existe um projeto com esse nome",
              type: "error",
            });
            return;
          } else {
            setLoading({
              loading: true,
              id: loadingId,
              message: "Criando projeto...",
            });

            const createProjeto = await createProjetoApi({
              idUsuario: currentUser.IdUsuario,
              nome: createProjetoForm.fields.nome,
            });

            const projetos = await getProjetosApi({
              filter: {
                idUsuario: currentUser.IdUsuario,
                inclusaoMax: undefined,
                inclusaoMin: undefined,
              },
              pagination: {
                page: projetosPagination.page,
                pageSize: projetosPagination.limit,
              },
            });

            dispatch(
              setProjetosState({
                projetos: projetos.projetos,
                total: projetos.total,
              })
            );

            setOpenCreateProjetoForm(false);
            setAlert({
              message: "Projeto criado com sucesso",
              type: "success",
            });

            navigate(`/geo-veles/projetos/${createProjeto.IdVelesGeoProjeto}`);
          }
        }
      } catch (err: any) {
        setAlert({
          message: err.response.data.message,
          type: "error",
        });
      } finally {
        setLoading({
          loading: false,
          id: loadingId,
        });
      }
    }
  }, [
    currentUser,
    createProjetoForm.fields,
    dispatch,
    verifyNomeProjetoExistsApi,
    setAlert,
    setLoading,
    createProjetoApi,
    getProjetosApi,
    projetosPagination.page,
    projetosPagination.limit,
    setOpenCreateProjetoForm,
    navigate,
  ]);

  const setOpenEditProjetoForm = useCallback(
    async (data: { open: boolean; idVelesGeoProjeto?: number }) => {
      const loadingId = Math.random().toString();
      setLoading({
        loading: true,
        id: loadingId,
        message: "Carregando informações do projeto",
      });
      try {
        if (data.open) {
          if (data.idVelesGeoProjeto) {
            const findProject = await getProjetoByIdApi({
              idVelesGeoProjeto: data.idVelesGeoProjeto,
            });

            dispatch(
              setEditProjetoFormAtivoState({
                ativo: findProject.Ativo,
              })
            );

            dispatch(
              setEditProjetoFormIdVelesGeoProjetoState({
                idVelesGeoProjeto: findProject.IdVelesGeoProjeto,
              })
            );

            dispatch(
              setEditProjetoFormNomeState({
                nome: findProject.Nome,
              })
            );
          }
          dispatch(setOpenEditProjetoFormState(true));
        } else {
          dispatch(resetEditProjetoFormState());
        }
      } catch (error: any) {
        setAlert({
          message: error.response.data.error,
          type: "error",
        });
      } finally {
        setLoading({
          loading: false,
          id: loadingId,
        });
      }
    },
    [dispatch, getProjetoByIdApi, navigate, setAlert, setLoading]
  );

  const updateProjeto = useCallback(async () => {
    if (currentUser) {
      const loadingId = Math.random().toString();

      try {
        const errors = validateEditProjetoForm(editProjetoForm.fields);

        if (errors.length > 0) {
          dispatch(
            setEditProjetoFormErrorsState({
              errors: errors,
            })
          );
          dispatch(
            setEditProjetoFormTouchedState({
              touched: true,
            })
          );
        } else {
          if (editProjetoForm.fields.idVelesGeoProjeto) {
            const verifyNomeProjetoExists: boolean = await verifyNomeProjetoExistsApi({
              idUsuario: currentUser.IdUsuario,
              nome: editProjetoForm.fields.nome.trim(),
              idVelesGeoProjeto: editProjetoForm.fields.idVelesGeoProjeto,
            });

            //NÃO APAGAR ESSE COMENTÁRIO ABAIXO!!
            //SERÉ NECESSÁRIO CRIAR UMA TASK APENAS PARA CORREÇÃO 
            //RAFAEL 11/05/2026
            // if (!verifyNomeProjetoExists) {
            //   setAlert({
            //     message: "Já existe um projeto ativo com esse nome",
            //     type: "error",
            //   });
            //   return;
            // }

            setLoading({
              loading: true,
              id: loadingId,
              message: "Atualizando projeto...",
            });

            const updatedProjeto = await updateProjetoNomeAndAtivoApi({
              idVelesGeoProjeto: editProjetoForm.fields.idVelesGeoProjeto,
              ativo: editProjetoForm.fields.ativo,
              nome: editProjetoForm.fields.nome,
            });

            if (projetoAberto?.IdVelesGeoProjeto === updatedProjeto.IdVelesGeoProjeto) {
              dispatch(setProjetoAbertoState(updatedProjeto));
            }

            const updatedProjetosList = projetos.map((p) =>
              p.IdVelesGeoProjeto === updatedProjeto.IdVelesGeoProjeto
                ? { ...p, ...updatedProjeto }
                : p
            );

            dispatch(
              setProjetosState({
                projetos: updatedProjetosList,
                total: projetosTotal,
              })
            );

            await setProjetos();

            setOpenEditProjetoForm({
              open: false,
            });

            dispatch(resetEditProjetoFormState());
            setAlert({
              message: "Projeto atualizado com sucesso",
              type: "success",
            });
          }
        }
      } catch (error: any) {
        setAlert({
          message: error.response?.data?.message || "Erro ao atualizar projeto",
          type: "error",
        });
      } finally {
        setLoading({
          loading: false,
          id: loadingId,
        });
      }
    }
  }, [
    currentUser,
    setLoading,
    editProjetoForm.fields,
    dispatch,
    verifyNomeProjetoExistsApi,
    setAlert,
    updateProjetoNomeAndAtivoApi,
    setOpenEditProjetoForm,
    projetoAberto,
    setProjetos,
    projetos,
    projetosTotal,
  ]);

  const archiveProjeto = useCallback(async (data: { idVelesGeoProjeto: number, ativo: boolean, nome: string }) => {
    const loadingId = Math.random().toString();
    setLoading({
      loading: true,
      id: loadingId,
      message: data.ativo ? "Ativando projeto..." : "Arquivando projeto...",
    });
    try {
      await updateProjetoNomeAndAtivoApi({
        idVelesGeoProjeto: data.idVelesGeoProjeto,
        ativo: data.ativo,
        nome: data.nome,
      });

      setAlert({
        message: data.ativo ? "Projeto ativado com sucesso" : "Projeto arquivado com sucesso",
        type: "success",
      });

      await setProjetos();
    } catch (error: any) {
      setAlert({
        message: error.response?.data?.error || "Erro ao atualizar status do projeto",
        type: "error",
      });
    } finally {
      setLoading({
        loading: false,
        id: loadingId,
      });
    }
  }, [updateProjetoNomeAndAtivoApi, setAlert, setLoading, setProjetos]);

  const updateFiltrosProjeto = useCallback(async () => {
    if (currentUser) {
      if (projetoAberto) {
        dispatch(
          setRelatorioProjetoState({
            relatorioProjeto: undefined,
          })
        );

        if (filtrosSelecionados) {
          try {
            let hasFilter: boolean = false;
            hasFilter = verificarFiltros();

            if (!hasFilter) {
              setAlert({
                message:
                  "Pelo menos 1(um) filtro deve estar selecionado para a pesquisa",
                type: "error",
              });
              return;
            }

            if (
              filtrosSelecionados.idade ||
              filtrosSelecionados.dataNascimento
            ) {
              if (filtrosSelecionados.idade?.min) {
                if (filtrosSelecionados.idade?.min < 18) {
                  setAlert({
                    message:
                      "Não buscamos menores de idade. Corrija a idade mínima.",
                    type: "error",
                  });
                  return;
                }
              }

              if (filtrosSelecionados.idade?.max) {
                if (filtrosSelecionados.idade?.max > 120) {
                  setAlert({
                    message: "Digite uma idade menor que 120 anos.",
                    type: "error",
                  });
                  return;
                }
              }

              if (filtrosSelecionados.dataNascimento?.min) {
                if (!verificarIdade(filtrosSelecionados.dataNascimento.min)) {
                  setAlert({
                    message:
                      "Não buscamos menores de idade. Corrija a data de nascimento.",
                    type: "error",
                  });
                  return;
                }
              }
            }
            const loadingId = Math.random().toString();
            setLoading({
              id: loadingId,
              loading: true,
              message: "Buscando pessoas...",
            });
            // ✅ Mapear listasCbo para listaCBO (backend espera singular)
            const filtrosParaEnviar = {
              ...filtrosSelecionados,
              listaCBO: filtrosSelecionados.listasCbo, // ✅ Mapear para singular
              listasCbo: undefined, // ✅ Remover o plural
            };

            const updateProjeto = await updateFiltrosProjetoApi({
              filtros: filtrosParaEnviar,
              idVelesGeoProjeto: projetoAberto.IdVelesGeoProjeto,
            });

            dispatch(
              setRelatorioProjetoState({
                relatorioProjeto: updateProjeto.relatorioProjeto,
              })
            );

            dispatch(setProjetoActionState("exportar"));
          } catch (error: any) {
            setAlert({
              message: error.response.data.error,
              type: "error",
            });
          } finally {
            const loadingId = Math.random().toString();
            setLoading({
              id: loadingId,
              loading: false,
            });
          }
        }
      }
    }
  }, [
    currentUser,
    dispatch,
    filtrosSelecionados,
    projetoAberto,
    setAlert,
    setLoading,
    updateFiltrosProjetoApi,
  ]);

  const verificarFiltros = () => {
    const filtros = filtrosSelecionados;
    try {
      let hasFilter: boolean = false;
      if (filtrosSelecionados) {
        if (filtros?.hasOwnProperty("localizacao") && !hasFilter) {
          if (filtros?.localizacao) {
            if (filtros?.localizacao.length > 0) {
              hasFilter = true;
            }
          }
        }

        if (
          filtrosSelecionados.hasOwnProperty("purgeLocalizacao") &&
          !hasFilter
        ) {
          if (filtrosSelecionados.purgeLocalizacao) {
            if (filtrosSelecionados.purgeLocalizacao.length > 0) {
              hasFilter = true;
            }
          }
        }

        // listasCEP?: number[]
        if (filtrosSelecionados.hasOwnProperty("listasCEP") && !hasFilter) {
          if (filtrosSelecionados.listasCEP) {
            if (filtrosSelecionados.listasCEP.length > 0) {
              hasFilter = true;
            }
          }
        }

        // purgeListasCEP?: number[]
        if (
          filtrosSelecionados.hasOwnProperty("purgeListasCEP") &&
          !hasFilter
        ) {
          if (filtrosSelecionados.purgeListasCEP) {
            if (filtrosSelecionados.purgeListasCEP.length > 0) {
              hasFilter = true;
            }
          }
        }

        // listasCidades?: number[]
        if (filtrosSelecionados.hasOwnProperty("listasCidades") && !hasFilter) {
          if (filtrosSelecionados.listasCidades) {
            if (filtrosSelecionados.listasCidades.length > 0) {
              hasFilter = true;
            }
          }
        }

        // purgeListasCidades?: number[]
        if (
          filtrosSelecionados.hasOwnProperty("purgeListasCidades") &&
          !hasFilter
        ) {
          if (filtrosSelecionados.purgeListasCidades) {
            if (filtrosSelecionados.purgeListasCidades.length > 0) {
              hasFilter = true;
            }
          }
        }

        // listaCbo?: number[]
        if (filtrosSelecionados.hasOwnProperty("listasCbo") && !hasFilter) {
          if (filtrosSelecionados.listasCbo) {
            if (filtrosSelecionados.listasCbo.length > 0) {
              hasFilter = true;
            }
          }
        }

        // listasDeduplicacao?: number[]
        if (
          filtrosSelecionados.hasOwnProperty("listasDeduplicacao") &&
          !hasFilter
        ) {
          if (filtrosSelecionados.listasDeduplicacao) {
            if (filtrosSelecionados.listasDeduplicacao.length > 0) {
              hasFilter = true;
            }
          }
        }
        // geolocalizacao?: {
        if (
          filtrosSelecionados.hasOwnProperty("geolocalizacao") &&
          !hasFilter
        ) {
          if (filtrosSelecionados.geolocalizacao) {
            if (filtrosSelecionados.geolocalizacao.data) {
              if (filtrosSelecionados.geolocalizacao.data !== null) {
                hasFilter = true;
              }
            } else if (filtrosSelecionados.geolocalizacao.radius) {
              if (filtrosSelecionados.geolocalizacao.radius > 0) {
                hasFilter = true;
              }
            }
          }
        }

        // sexo?: ISexo[]
        if (filtrosSelecionados.hasOwnProperty("sexo") && !hasFilter) {
          if (filtrosSelecionados.sexo) {
            if (filtrosSelecionados.sexo.length > 0) {
              hasFilter = true;
            }
          }
        }

        // idade?: IAge
        if (filtrosSelecionados.hasOwnProperty("idade") && !hasFilter) {
          if (filtrosSelecionados.idade) {
            if (filtrosSelecionados.idade.min) {
              if (filtrosSelecionados.idade.min > 0) {
                hasFilter = true;
              }
            } else if (filtrosSelecionados.idade.max) {
              if (filtrosSelecionados.idade.max > 0) {
                hasFilter = true;
              }
            }
          }
        }

        // dataNascimento?: IDataNascimentoFilter
        if (filtrosSelecionados.hasOwnProperty("dataNascimento")) {
          if (filtrosSelecionados.dataNascimento) {
            if (filtrosSelecionados.dataNascimento.min) {
              hasFilter = true;
            } else if (filtrosSelecionados.dataNascimento.max) {
              hasFilter = true;
            }
          }
        }
        // rendaPresumidaMensal?: IRenda
        if (filtrosSelecionados.hasOwnProperty("rendaPresumidaMensal")) {
          if (filtrosSelecionados.rendaPresumidaMensal) {
            if (filtrosSelecionados.rendaPresumidaMensal.min) {
              if (filtrosSelecionados.rendaPresumidaMensal.min > 0) {
                hasFilter = true;
              }
            } else if (filtrosSelecionados.rendaPresumidaMensal.max) {
              if (filtrosSelecionados.rendaPresumidaMensal.max > 0) {
                hasFilter = true;
              }
            }
          }
        }

        // rendaPresumidaAnual?: IRenda
        if (filtrosSelecionados.hasOwnProperty("rendaPresumidaAnual")) {
          if (filtrosSelecionados.rendaPresumidaAnual) {
            if (filtrosSelecionados.rendaPresumidaAnual.min) {
              if (filtrosSelecionados.rendaPresumidaAnual.min > 0) {
                hasFilter = true;
              }
            } else if (filtrosSelecionados.rendaPresumidaAnual.max) {
              if (filtrosSelecionados.rendaPresumidaAnual.max > 0) {
                hasFilter = true;
              }
            }
          }
        }

        // classeSocial?: IClasseSocial[]
        if (filtrosSelecionados.hasOwnProperty("classeSocial")) {
          if (filtrosSelecionados.classeSocial) {
            if (filtrosSelecionados.classeSocial.length > 0) {
              hasFilter = true;
            }
          }
        }

        // escolaridade?: IEscolaridade[]
        if (filtrosSelecionados.hasOwnProperty("escolaridade")) {
          if (filtrosSelecionados.escolaridade) {
            if (filtrosSelecionados.escolaridade.length > 0) {
              hasFilter = true;
            }
          }
        }
        // scoreVeles?: IScoreVeles[]
        if (filtrosSelecionados.hasOwnProperty("scoreVeles")) {
          if (filtrosSelecionados.scoreVeles) {
            if (filtrosSelecionados.scoreVeles.length > 0) {
              hasFilter = true;
            }
          }
        }
        // cbo?: IOcupacao[]
        if (filtrosSelecionados.hasOwnProperty("cbo")) {
          if (filtrosSelecionados.cbo) {
            if (filtrosSelecionados.cbo.length > 0) {
              hasFilter = true;
            }
          }
        }
        // profissao?: IOcupacao[]
        if (filtrosSelecionados.hasOwnProperty("profissao")) {
          if (filtrosSelecionados.profissao) {
            if (filtrosSelecionados.profissao.length > 0) {
              hasFilter = true;
            }
          }
        }
        // contato?: IContato[]
        if (filtrosSelecionados.hasOwnProperty("contato")) {
          if (filtrosSelecionados.contato) {
            if (filtrosSelecionados.contato.length > 0) {
              hasFilter = true;
            }
          }
        }
        // estadoCivil?: IEstadoCivil[]
        if (filtrosSelecionados.hasOwnProperty("estadoCivil")) {
          if (filtrosSelecionados.estadoCivil) {
            if (filtrosSelecionados.estadoCivil.length > 0) {
              hasFilter = true;
            }
          }
        }
      }
      return hasFilter;
    } catch (error) {
      return false;
    }
  };

  const setProjetosPagination = useCallback(
    (data: { page: number; limit: number }) => {
      dispatch(
        setProjetosPaginationState({
          page: data.page,
          limit: data.limit,
        })
      );
    },
    [dispatch]
  );

  const setCreateProjetoFormNome = useCallback(
    (nome: string) => {
      resetFiltros();

      dispatch(
        setCreateProjetoFormNomeState({
          nome: nome,
        })
      );
    },
    [dispatch]
  );

  const setEditProjetoFormNome = useCallback(
    (nome: string) => {
      dispatch(
        setEditProjetoFormNomeState({
          nome: nome,
        })
      );
    },
    [dispatch]
  );

  const setEditProjetoFormAtivo = useCallback(
    (ativo: boolean) => {
      dispatch(
        setEditProjetoFormAtivoState({
          ativo: ativo,
        })
      );
    },
    [dispatch]
  );

  const openProjeto = useCallback(
    (idVelesGeoProjeto: number) => {
      dispatch(
        setRelatorioProjetoState({
          relatorioProjeto: undefined,
        })
      );
      navigate(`/geo-veles/projetos/${idVelesGeoProjeto}`);
    },
    [dispatch, navigate]
  );

  const setProjetoAberto = useCallback(
    async (idVelesGeoProjeto: number) => {
      const loadingId = Math.random().toString();
      setLoading({
        loading: true,
        id: loadingId,
        message: "Abrindo projeto...",
      });

      try {
        const findProjeto = await getProjetoByIdApi({
          idVelesGeoProjeto: idVelesGeoProjeto,
        });

        dispatch(setProjetoAbertoState(findProjeto));
        if (findProjeto.Filtros) {
          if (findProjeto.Filtros.geolocalizacao) {
            dispatch(
              setSelectedGeolocalizacaoState({
                geolocalizacao: findProjeto.Filtros.geolocalizacao.data,
              })
            );
            dispatch(
              setGeolocalizacaoRadiusState({
                radius: findProjeto.Filtros.geolocalizacao.radius * 1000,
              })
            );
          }
        }
      } catch (error: any) {
        setAlert({
          message: error.response.data.error,
          type: "error",
        });
        navigate("/geo-veles/projetos");
      } finally {
        setLoading({
          loading: false,
          id: loadingId,
        });
      }
    },
    [dispatch, getProjetoByIdApi, navigate, setAlert, setLoading]
  );

  const setProjetoAction = useCallback(
    (action: IActionTypes) => {
      dispatch(setProjetoActionState(action));
    },
    [dispatch]
  );

  const resetProjetoAction = useCallback(() => {
    dispatch(resetProjetoActionState());
  }, [dispatch]);

  const setProjetoFiltroAtivo = useCallback(
    (filtroAtivo: number) => {
      dispatch(setProjetoFiltroAtivoState(filtroAtivo));
    },
    [dispatch]
  );

  const resetProjetoFiltroAtivo = useCallback(() => {
    dispatch(resetProjetoFiltroAtivoState());
  }, [dispatch]);

  // Filtros

  const addListaCBOFilter = useCallback(
    (cbo: IListaCbo) => {
      dispatch(
        addListaCBOFilterState({
          idVelesGeoListaCBO: cbo.IdVelesGeoListaCBO
        })
      );
    },
    [dispatch]
  );

  const removeListaCBOFilter = useCallback(
    (cbo: IListaCbo) => {
      dispatch(
        removeListaCBOFilterState({
          idVelesGeoListaCBO: cbo.IdVelesGeoListaCBO
        })
      );
    },
    [dispatch]
  );

  const addLocalizacaoFilter = useCallback(
    (localizacao: ILocalizacao) => {
      dispatch(
        addLocalizacaoFilterState({
          localizacao: localizacao,
        })
      );
    },
    [dispatch]
  );

  const removeLocalizacaoFilter = useCallback(
    (localizacao: ILocalizacao) => {
      dispatch(
        removeLocalizacaoFilterState({
          localizacao: localizacao,
        })
      );
    },
    [dispatch]
  );

  const addPurgeLocalizacaoFilter = useCallback(
    (localizacao: ILocalizacao) => {
      dispatch(
        addPurgeLocalizacaoFilterState({
          localizacao: localizacao,
        })
      );
    },
    [dispatch]
  );

  const removePurgeLocalizacaoFilter = useCallback(
    (localizacao: ILocalizacao) => {
      dispatch(
        removePurgeLocalizacaoFilterState({
          localizacao: localizacao,
        })
      );
    },
    [dispatch]
  );

  const addListaCEPFilter = useCallback(
    (idVelesGeoListaCEP: number) => {
      dispatch(
        addListaCEPFilterState({
          idVelesGeoListaCEP: idVelesGeoListaCEP,
        })
      );
    },
    [dispatch]
  );

  const removeListaCEPFilter = useCallback(
    (idVelesGeoListaCEP: number) => {
      dispatch(
        removeListaCEPFilterState({
          idVelesGeoListaCEP: idVelesGeoListaCEP,
        })
      );
    },
    [dispatch]
  );

  const addPurgeListaCEPFilter = useCallback(
    (idVelesGeoListaCEP: number) => {
      dispatch(
        addPurgeListaCEPFilterState({
          idVelesGeoListaCEP: idVelesGeoListaCEP,
        })
      );
    },
    [dispatch]
  );

  const removePurgeListaCEPFilter = useCallback(
    (idVelesGeoListaCEP: number) => {
      dispatch(
        removePurgeListaCEPFilterState({
          idVelesGeoListaCEP: idVelesGeoListaCEP,
        })
      );
    },
    [dispatch]
  );

  const addListaCidadesFilter = useCallback(
    (idVelesGeoListaCidade: number) => {
      dispatch(
        addListaCidadesFilterState({
          idVelesGeoListaCidade: idVelesGeoListaCidade,
        })
      );
    },
    [dispatch]
  );

  const removeListaCidadesFilter = useCallback(
    (idVelesGeoListaCidade: number) => {
      dispatch(
        removeListaCidadesFilterState({
          idVelesGeoListaCidade: idVelesGeoListaCidade,
        })
      );
    },
    [dispatch]
  );

  const addPurgeListaCidadesFilter = useCallback(
    (idVelesGeoListaCidade: number) => {
      dispatch(
        addPurgeListaCidadesFilterState({
          idVelesGeoListaCidade: idVelesGeoListaCidade,
        })
      );
    },
    [dispatch]
  );

  const removePurgeListaCidadesFilter = useCallback(
    (idVelesGeoListaCidade: number) => {
      dispatch(
        removePurgeListaCidadesFilterState({
          idVelesGeoListaCidade: idVelesGeoListaCidade,
        })
      );
    },
    [dispatch]
  );

  const setGeolocalizacaoFilter = useCallback(
    (data: {
      geolocalizacao: {
        data: IGeolocalizacao;
        radius: number;
      };
    }) => {
      dispatch(
        setGeolocalizacaoFilterState({
          geolocalizacao: {
            data: data.geolocalizacao.data,
            radius: data.geolocalizacao.radius / 1000,
          },
        })
      );
    },
    [dispatch]
  );

  const setGeolocalizacaoFilterRadius = useCallback(
    (data: { radius: number }) => {
      dispatch(
        setGeolocalizacaoFilterRadiusState({
          radius: data.radius / 1000,
        })
      );
    },
    [dispatch]
  );

  const resetGeolocalizacaoFilter = useCallback(() => {
    dispatch(resetGeolocalizacaoFilterState());
  }, [dispatch]);

  const addSexoFilter = useCallback(
    (sexo: ISexo) => {
      dispatch(
        addSexoFilterState({
          sexo: sexo,
        })
      );
    },
    [dispatch]
  );

  const removeSexoFilter = useCallback(
    (sexo: ISexo) => {
      dispatch(
        removeSexoFilterState({
          sexo: sexo,
        })
      );
    },
    [dispatch]
  );

  const setMaxIdadeFilter = useCallback(
    (maxIdade?: number) => {
      dispatch(
        setMaxIdadeFilterState({
          maxIdade: maxIdade,
        })
      );
    },
    [dispatch]
  );

  const setMinIdadeFilter = useCallback(
    (minIdade?: number) => {
      dispatch(
        setMinIdadeFilterState({
          minIdade: minIdade,
        })
      );
    },
    [dispatch]
  );

  const resetIdadeFilter = useCallback(() => {
    dispatch(resetIdadeFilterState());
  }, [dispatch]);

  const setMaxDataNascimentoFilter = useCallback(
    (maxDataNascimento?: Date) => {
      dispatch(
        setMaxDataNascimentoFilterState({
          maxDataNascimento: maxDataNascimento,
        })
      );
    },
    [dispatch]
  );

  const setMinDataNascimentoFilter = useCallback(
    (minDataNascimento?: Date) => {
      dispatch(
        setMinDataNascimentoFilterState({
          minDataNascimento: minDataNascimento,
        })
      );
    },
    [dispatch]
  );

  const resetDataNascimentoFilter = useCallback(() => {
    dispatch(resetDataNascimentoFilterState());
  }, [dispatch]);

  const setMaxRendaMensalFilter = useCallback(
    (maxRendaMensal?: number) => {
      dispatch(
        setMaxRendaMensalFilterState({
          maxRendaMensal: maxRendaMensal,
        })
      );
    },
    [dispatch]
  );

  const setMinRendaMensalFilter = useCallback(
    (minRendaMensal?: number) => {
      dispatch(
        setMinRendaMensalFilterState({
          minRendaMensal: minRendaMensal,
        })
      );
    },
    [dispatch]
  );

  const resetRendaMensalFilter = useCallback(() => {
    dispatch(resetRendaMensalFilterState());
  }, [dispatch]);

  const setMaxRendaAnualFilter = useCallback(
    (maxRendaAnual?: number) => {
      dispatch(
        setMaxRendaAnualFilterState({
          maxRendaAnual: maxRendaAnual,
        })
      );
    },
    [dispatch]
  );

  const setMinRendaAnualFilter = useCallback(
    (minRendaAnual?: number) => {
      dispatch(
        setMinRendaAnualFilterState({
          minRendaAnual: minRendaAnual,
        })
      );
    },
    [dispatch]
  );

  const resetRendaAnualFilter = useCallback(() => {
    dispatch(resetRendaAnualFilterState());
  }, [dispatch]);

  const addClasseSocialFilter = useCallback(
    (classeSocial: IClasseSocial) => {
      dispatch(
        addClasseSocialFilterState({
          classeSocial: classeSocial,
        })
      );
    },
    [dispatch]
  );

  const removeClasseSocialFilter = useCallback(
    (classeSocial: IClasseSocial) => {
      dispatch(
        removeClasseSocialFilterState({
          classeSocial: classeSocial,
        })
      );
    },
    [dispatch]
  );

  const addEscolaridadeFilter = useCallback(
    (escolaridade: IEscolaridade) => {
      dispatch(
        addEscolaridadeFilterState({
          escolaridade: escolaridade,
        })
      );
    },
    [dispatch]
  );

  const removeEscolaridadeFilter = useCallback(
    (escolaridade: IEscolaridade) => {
      dispatch(
        removeEscolaridadeFilterState({
          escolaridade: escolaridade,
        })
      );
    },
    [dispatch]
  );

  const addScoreVelesFilter = useCallback(
    (scoreVeles: IScoreVeles) => {
      dispatch(
        addScoreVelesFilterState({
          scoreVeles: scoreVeles,
        })
      );
    },
    [dispatch]
  );

  const removeScoreVelesFilter = useCallback(
    (scoreVeles: IScoreVeles) => {
      dispatch(
        removeScoreVelesFilterState({
          scoreVeles: scoreVeles,
        })
      );
    },
    [dispatch]
  );

  // ############################################# SITUAÇÃO CADASTRAL

  const addSituacaoCadastralFilter = useCallback(
    (situacaoCadastral: ISituacaoCadastral) => {
      dispatch(
        addSituacaoCadastralFilterState({
          situacaoCadastral: situacaoCadastral,
        })
      );
    },
    [dispatch]
  );

  const removeSituacaoCadastralFilter = useCallback(
    (situacaoCadastral: ISituacaoCadastral) => {
      dispatch(
        removeSituacaoCadastralFilterState({
          situacaoCadastral: situacaoCadastral,
        })
      );
    },
    [dispatch]
  );

  const addContatoFilter = useCallback(
    (contato: IContato) => {
      dispatch(
        addContatoFilterState({
          contato: contato,
        })
      );
    },
    [dispatch]
  );

  const removeContatoFilter = useCallback(
    (contato: IContato) => {
      dispatch(
        removeContatoFilterState({
          contato: contato,
        })
      );
    },
    [dispatch]
  );

  const addEstadoCivilFilter = useCallback(
    (estadoCivil: IEstadoCivil) => {
      dispatch(
        addEstadoCivilFilterState({
          estadoCivil: estadoCivil,
        })
      );
    },
    [dispatch]
  );

  const removeEstadoCivilFilter = useCallback(
    (estadoCivil: IEstadoCivil) => {
      dispatch(
        removeEstadoCivilFilterState({
          estadoCivil: estadoCivil,
        })
      );
    },
    [dispatch]
  );

  const addCBOFilter = useCallback(
    (ocupacao: IOcupacao) => {
      dispatch(addCBOFilterState(ocupacao));
    },
    [dispatch]
  );

  const removeCBOFilter = useCallback(
    (ocupacao: IOcupacao) => {
      dispatch(removeCBOFilterState(ocupacao));
    },
    [dispatch]
  );

  const addProfissaoFilter = useCallback(
    (ocupacao: IOcupacao) => {
      dispatch(addProfissaoFilterState(ocupacao));
    },
    [dispatch]
  );

  const removeProfissaoFilter = useCallback(
    (ocupacao: IOcupacao) => {
      dispatch(removeProfissaoFilterState(ocupacao));
    },
    [dispatch]
  );

  // Actions
  const resetFiltros = useCallback(() => {
    dispatch(resetFiltrosSelecionadosState());

    dispatch(setProjetoFiltroAtivoState(0));

    dispatch(
      setRelatorioProjetoState({
        relatorioProjeto: undefined,
      })
    );

    dispatch(
      setProjetoActiveSectionState({
        activeSection: "filtros",
      })
    );
    let action: IActionTypes = "atualizar";
    dispatch(setProjetoActionState(action));

    // ✅ Limpa também as listas CBO selecionadas
    dispatch(clearSelectedListasCbo());

    if (projetoAberto) {
      dispatch(
        setProjetoAbertoState({
          ...projetoAberto,
          Filtros: {},
        })
      );
    }
  }, [dispatch, projetoAberto]);

  const resetProjetoAberto = useCallback(() => {
    dispatch(resetProjetoAbertoState());

    dispatch(
      setRelatorioProjetoState({
        relatorioProjeto: undefined,
      })
    );

    dispatch(setOpenExportTypeState(false));

    navigate("/geo-veles/projetos");
  }, [dispatch, navigate]);

  const setProjetoActiveSection = useCallback(
    (data: { activeDataSection: IActiveSection }) => {
      if (data.activeDataSection === "filtros") {
        dispatch(
          setProjetoActiveSectionState({
            activeSection: data.activeDataSection,
          })
        );
        return;
      } else {
        if (!relatorioProjeto) {
          setAlert({
            message:
              'Clique no botão "' +
              "Atualizar  " +
              '" para gerar  os dados da amostragem.',
            type: "info",
          });
          return;
        } else {
          dispatch(
            setProjetoActiveSectionState({
              activeSection: data.activeDataSection,
            })
          );
          return;
        }
      }
    },
    [dispatch, relatorioProjeto, setAlert]
  );

  const setPage = useCallback(
    (data: { page: number }) => {
      dispatch(
        setProjetoPageState({
          page: data.page,
        })
      );
    },
    [dispatch]
  );

  const setLimit = useCallback(
    (data: { limit: number }) => {
      dispatch(
        setProjetoLimitState({
          limit: data.limit,
        })
      );
    },
    [dispatch]
  );

  const setOpenExportType = useCallback(
    (open: boolean) => {
      dispatch(setOpenExportTypeState(open));
    },
    [dispatch]
  );

  const setCreateExtracaoFormNome = useCallback(
    (nome: string) => {
      const nomeTrimmed = nome.trim();
      const teste: string =
        nomeTrimmed + "-" + uuidv4().split("-")[0].toString();
      dispatch(setCreateExtracaoFormNomeState({ nome: teste }));
    },
    [dispatch]
  );

  const setCreateExtracaoFormQuantidade = useCallback(
    (quantidade: string) => {
      const quantidadeValor = Number(onlyNumbers(quantidade));

      dispatch(
        setCreateExtracaoFormQuantidadeState({ quantidade: quantidadeValor })
      );
    },
    [dispatch]
  );

  const verifyTravaConsumo = useCallback(
    async (data: { IdCliente: number; IdUsuario: number }) => {
      const getTravaConsumo = await getTravaConsumoApi({
        IdCliente: data.IdCliente,
        IdUsuario: data.IdUsuario,
      });
      if (getTravaConsumo) {
        dispatch(setTravaConsumoState(getTravaConsumo));
      }
    },
    [dispatch, getTravaConsumoApi]
  );

  const setVerifyAcesso = useCallback(async () => {
    const getAcesso: IAcesso = await verifyAccessProductApi({
      IdUsuario: currentUser?.IdUsuario ?? 0,
      IdProduto: Number(IProdutosEnum.geo_veles),
    });

    if (getAcesso) {
      dispatch(setCurrentAccessState(getAcesso));
    }
  }, [currentUser, dispatch, verifyAccessProductApi]);

  const verifyNumeroExtracao = useCallback((): [boolean, string] => {
    try {
      const qtdDigitada = createExtracaoForm.fields.quantidade;
      const qtdProjeto: number | undefined =
        relatorioProjeto?.dados.disponiveis ?? 0;

      if (qtdDigitada <= qtdProjeto) {
        if (access) {
          const freshTravaConsumo = store.getState().travaConsumo;
          const clienteTemLimite =
            freshTravaConsumo.data.travaConsumo.ClienteTravaQuantidade > 0;
          const usuarioTemLimite =
            freshTravaConsumo.data.travaConsumo.UsuarioTravaQuantidade > 0;
          const perfilTemLimite =
            freshTravaConsumo.data.travaConsumo.PerfilTravaQuantidade > 0;
          const fmtMax = (n: number) =>
            Math.max(0, Math.floor(Number(n))).toLocaleString("pt-BR");
          if (
            clienteTemLimite &&
            qtdDigitada >
            freshTravaConsumo.data.travaConsumo.ClienteTravaQuantidade -
            freshTravaConsumo.data.travaConsumo.ClienteConsumiu
          ) {
            const limiteTravaCliente =
              freshTravaConsumo.data.travaConsumo.ClienteTravaQuantidade;
            const restanteCliente =
              limiteTravaCliente -
              freshTravaConsumo.data.travaConsumo.ClienteConsumiu;
            return [
              false,
              `O limite da trava do cliente de ${fmtMax(
                limiteTravaCliente
              )} registro(s) foi excedido. Neste período você pode solicitar no máximo ${fmtMax(
                restanteCliente
              )} registro(s).`,
            ];
          } else if (
            usuarioTemLimite &&
            qtdDigitada >
            freshTravaConsumo.data.travaConsumo.UsuarioTravaQuantidade -
            freshTravaConsumo.data.travaConsumo.UsuarioConsumiu
          ) {
            const limiteTravaUsuario =
              freshTravaConsumo.data.travaConsumo.UsuarioTravaQuantidade;
            const restanteUsuario =
              limiteTravaUsuario -
              freshTravaConsumo.data.travaConsumo.UsuarioConsumiu;
            return [
              false,
              `O limite da trava do usuário de ${fmtMax(
                limiteTravaUsuario
              )} registro(s) foi excedido. Neste período você pode solicitar no máximo ${fmtMax(
                restanteUsuario
              )} registro(s).`,
            ];
          } else if (
            perfilTemLimite &&
            qtdDigitada >
            freshTravaConsumo.data.travaConsumo.PerfilTravaQuantidade -
            freshTravaConsumo.data.travaConsumo.PerfilConsumiu
          ) {
            const limiteTravaPerfil =
              freshTravaConsumo.data.travaConsumo.PerfilTravaQuantidade;
            const restantePerfil =
              limiteTravaPerfil -
              freshTravaConsumo.data.travaConsumo.PerfilConsumiu;
            return [
              false,
              `O limite da trava do perfil de ${fmtMax(
                limiteTravaPerfil
              )} registro(s) foi excedido. Neste período você pode solicitar no máximo ${fmtMax(
                restantePerfil
              )} registro(s).`,
            ];
          } else if (
            qtdDigitada >
            freshTravaConsumo.data
              .quantidadeMaximaExtracaoPermitadaPorUsuarioExcetoVendedor
          ) {
            const limitePlat =
              freshTravaConsumo.data
                .quantidadeMaximaExtracaoPermitadaPorUsuarioExcetoVendedor;
            return [
              false,
              `O limite da plataforma de ${fmtMax(
                limitePlat
              )} registro(s) foi excedido.`,
            ];
          }
        }
      } else {
        return [
          false,
          `Quantidade máxima disponível no projeto com estes filtros: ${Math.max(
            0,
            Math.floor(Number(qtdProjeto))
          ).toLocaleString("pt-BR")} registro(s).`,
        ];
      }
      return [true, ""];
    } catch {
      return [false, "Erro ao verificar os dados digitados.."];
    }
  }, [
    createExtracaoForm.fields.quantidade,
    relatorioProjeto?.dados.disponiveis,
    access,
    travaConsumo.data,
  ]);

  const createExtracao = useCallback(async () => {
    setLoading({ loading: true, message: "Iniciando exportação...", id: "create-extracao" });
    try {
      await setVerifyAcesso();
      await verifyTravaConsumo({
        IdCliente: currentUser?.IdCliente ?? 0,
        IdUsuario: currentUser?.IdUsuario ?? 0,
      });

      const freshState = store.getState();
      const freshAccess = freshState.user.access;

      if (currentUser && freshAccess) {
        if (projetoAberto) {
          const verifyNomeExtracao: boolean = await verifyExtracoByNomeApi({
            nome: createExtracaoForm.fields.nome,
            idVelesGeoProjeto: projetoAberto.IdVelesGeoProjeto,
            idUsuario: currentUser.IdUsuario,
          });

          if (!verifyNomeExtracao) {
            dispatch(
              setCreateExtracaoFormNomeState({
                nome: createExtracaoForm.fields.nome.trim(),
              })
            );
            setAlert({
              message: "Já existe uma extração com este nome.",
              type: "error",
            });
            dispatch(setCreateExtracaoFormTouchedState({ touched: true }));
            return;
          } else {
            dispatch(
              setCreateExtracaoFormNomeState({
                nome: createExtracaoForm.fields.nome.trim(),
              })
            );
            if (relatorioProjeto) {
              let hasExtraction: any = undefined;
              hasExtraction = verifyNumeroExtracao();
              const msg: string = hasExtraction[1];
              if (!hasExtraction[0]) {
                setAlert({
                  message: msg,
                  type: "error",
                });
                dispatch(
                  setCreateExtracaoFormTouchedState({
                    touched: true,
                  })
                );
                return;
              }

              dispatch(
                setCreateExtracaoFormErrorsState({
                  errors: [],
                })
              );
              dispatch(
                setCreateExtracaoFormTouchedState({
                  touched: false,
                })
              );

              let errors: any = [];

              if (recorteExtracao.Recortes.length === 0) {
                errors = validateCreateExtracaoForm(createExtracaoForm.fields);
              }

              if (
                createExtracaoForm.fields.quantidade >
                relatorioProjeto.dados.disponiveis
              ) {
                if (recorteExtracao.Recortes.length === 0) {
                  errors.push({
                    key: "quantidade",
                    message: `O total de registros disponíveis com estes filtros é de ${relatorioProjeto.dados.disponiveis.toLocaleString(
                      "pt-BR"
                    )}`,
                  });
                }
              }

              if (errors.length > 0) {
                dispatch(
                  setCreateExtracaoFormErrorsState({
                    errors: errors,
                  })
                );
                dispatch(
                  setCreateExtracaoFormTouchedState({
                    touched: true,
                  })
                );
              } else {
                let quantidade = createExtracaoForm.fields.quantidade;

                if (recorteExtracao.Recortes.length > 0) {
                  quantidade = recorteExtracao.Recortes.reduce(
                    (total, item) => total + item.Quantidade,
                    0
                  );
                }

                await createExtracaoApi({
                  idVelesGeoProjeto: projetoAberto.IdVelesGeoProjeto,
                  idUsuario: currentUser.IdUsuario,
                  nome: createExtracaoForm.fields.nome,
                  quantidade,
                  filtros: filtrosSelecionados,
                  recortes:
                    recorteExtracao.Recortes.length > 0
                      ? recorteExtracao.Recortes
                      : null,
                  idAcesso: freshAccess.IdAcesso,
                });

                dispatch(resetCreateExtracaoFormState());
                dispatch(resetRecorteExtracaoState());
                quantidade = 0;
                dispatch(resetRelatorioProjetoState());
                setAlert({
                  message:
                    "Exportação criada com sucesso. O download iniciará em instantes",
                  type: "success",
                });

                navigateTo({
                  route: "/geo-veles/extracoes",
                });
              }
            }
          }
        }
      }
    } catch (error: any) {
      setAlert({
        message: error.response?.data?.error || "Erro ao criar extração.",
        type: "error",
      });
    } finally {
      setLoading({ loading: false, id: "create-extracao" });
    }
  }, [
    setVerifyAcesso,
    access,
    verifyTravaConsumo,
    currentUser,
    setAlert,
    projetoAberto,
    dispatch,
    relatorioProjeto,
    verifyNumeroExtracao,
    recorteExtracao,
    createExtracaoForm.fields,
    createExtracaoApi,
    filtrosSelecionados,
    navigateTo,
    setLoading,
  ]);

  const resetCreateExtracaoForm = useCallback(() => {
    dispatch(resetCreateExtracaoFormState());
  }, [dispatch]);

  const resetCreateExtracaoFormQuantidade = useCallback(() => {
    dispatch(resetCreateExtracaoFormState());
  }, [dispatch]);

  const setProjetoListFiltrosSearchTerm = useCallback(
    (searchTerm: string) => {
      dispatch(setProjetoListFiltrosSearchTermState(searchTerm));
    },
    [dispatch]
  );

  const resetProjetoListFiltrosSearchTerm = useCallback(() => {
    dispatch(resetProjetoListFiltrosSearchTermState());
  }, [dispatch]);

  const setProjetoListFiltrosInclusaoStart = useCallback(
    (dataInclusao: Date) => {
      dispatch(setProjetoListFiltrosInclusaoStartState(dataInclusao));
    },
    [dispatch]
  );

  const resetProjetoListFiltrosInclusaoStart = useCallback(() => {
    dispatch(resetProjetoListFiltrosInclusaoStartState());
  }, [dispatch]);

  const setProjetoListFiltrosInclusaoEnd = useCallback(
    (dataInclusao: Date) => {
      dispatch(setProjetoListFiltrosInclusaoEndState(dataInclusao));
    },
    [dispatch]
  );

  const resetProjetoListFiltrosInclusaoEnd = useCallback(() => {
    dispatch(resetProjetoListFiltrosInclusaoEndState());
  }, [dispatch]);

  const setProjetoListFiltrosAtivo = useCallback(
    (status: boolean) => {
      dispatch(setProjetoListFiltrosAtivoState(status));
    },
    [dispatch]
  );

  const resetProjetoListFiltrosAtivo = useCallback(() => {
    dispatch(resetProjetoListFiltrosAtivoState());
  }, [dispatch]);

  const resetProjetoListFiltros = useCallback(() => {
    dispatch(resetProjetoListFiltrosState());
  }, [dispatch]);

  const setProjetoListFiltrosUsuario = useCallback(
    (usuario: string) => {
      dispatch(setProjetoListFiltrosUsuarioState(usuario));
    },
    [dispatch]
  );

  const resetProjetoListFiltrosUsuario = useCallback(() => {
    dispatch(resetProjetoListFiltrosUsuarioState());
  }, [dispatch]);

  const setProjetoListFiltrosLoginUsuario = useCallback(
    (loginUsuario: string) => {
      dispatch(setProjetoListFiltrosLoginUsuarioState(loginUsuario));
    },
    [dispatch]
  );

  const resetProjetoListFiltrosLoginUsuario = useCallback(() => {
    dispatch(resetProjetoListFiltrosLoginUsuarioState());
  }, [dispatch]);

  const setProjetoListFiltrosCliente = useCallback(
    (LoginCliente: string) => {
      dispatch(setProjetoListFiltrosClienteState(LoginCliente));
    },
    [dispatch]
  );

  const resetProjetoListFiltrosCliente = useCallback(() => {
    dispatch(resetProjetoListFiltrosClienteState());
  }, [dispatch]);

  const addListaDeduplicacaoFilter = useCallback(
    (IdVelesGeoListaDeduplicacao: number) => {
      dispatch(
        addListaDeduplicacaoFilterState({ IdVelesGeoListaDeduplicacao })
      );
    },
    [dispatch]
  );

  const removeListaDeduplicacaoFilter = useCallback(
    (IdVelesGeoListaDeduplicacao: number) => {
      dispatch(
        removeListaDeduplicacaoFilterState({ IdVelesGeoListaDeduplicacao })
      );
    },
    [dispatch]
  );

  const setActiveDetailsSection = useCallback(
    (activeDetailsSectin: number) => {
      dispatch(setActiveDetailsSectionState(activeDetailsSectin));
    },
    [dispatch]
  );

  const resetRelatorioProjeto = () => {
    dispatch(
      setRelatorioProjetoState({
        relatorioProjeto: undefined,
      })
    );
  };

  const duplicateProjeto = useCallback(
    async (data: {
      idVelesGeoProjeto: number;
      nome: string;
      idUsuario: number;
    }) => {
      const loadingId = Math.random().toString();
      setLoading({
        id: loadingId,
        loading: true,
        message: "Duplicando projeto...",
      });

      try {
        const errors = validateDuplicateProjetoForm(
          duplicateProjetoForm.fields
        );
        if (errors.length > 0) {
          dispatch(
            setDuplicateProjetoFormErrorsState({
              errors: errors,
            })
          );
          dispatch(
            setEditProjetoFormTouchedState({
              touched: true,
            })
          );
        } else {
          const verifyNomeProjetoExists: boolean =
            await verifyNomeProjetoExistsApi({
              idUsuario: currentUser?.IdUsuario ?? 0,
              nome: duplicateProjetoForm.fields.nome.trim(),
            });

          if (!verifyNomeProjetoExists) {
            setAlert({
              message: "Já existe um projeto com esse nome",
              type: "error",
            });
            return;
          } else {
            const api = await duplicateProjetoApi({
              IdVelesGeoProjeto: data.idVelesGeoProjeto,
              nome: data.nome,
              IdUsuario: data.idUsuario,
            });

            if (api) {
              const idVelesGeoProjetoNovo = api.IdVelesGeoProjeto;

              setAlert({
                message: "Duplicação criada com sucesso",
                type: "success",
              });
              dispatch(resetDuplicateProjetoFormState);
              navigate(`/geo-veles/projetos/${idVelesGeoProjetoNovo}`);
            }
          }
        }
      } catch (error: any) {
        setAlert({
          message: error.response.data.message,
          type: "error",
        });
      } finally {
        setLoading({
          id: loadingId,
          loading: false,
        });
      }
    },
    [
      dispatch,
      duplicateProjetoApi,
      duplicateProjetoForm.fields,
      navigate,
      setAlert,
      setLoading,
      currentUser?.IdUsuario,
      verifyNomeProjetoExistsApi,
    ]
  );

  const setDuplicateProjetoFormNome = useCallback(
    (nome: string) => {
      dispatch(setDuplicateProjetoFormNomeState({ nome: nome }));
    },
    [dispatch]
  );

  const setOpenDuplicateProjetoForm = useCallback(
    async (data: {
      openForm: boolean;
      idVelesGeoProjeto?: number;
      nome?: string;
      idUsuario?: number;
    }) => {
      if (data.openForm) {
        dispatch(
          setDuplicateProjetoFormIdVelesGeoProjetoState({
            idVelesGeoProjeto: data.idVelesGeoProjeto ?? 0,
          })
        );

        dispatch(
          setDuplicateProjetoFormNomeState({
            nome: data.nome ?? "",
          })
        );

        dispatch(
          setCreateProjetoFormIdUsuarioState({
            idUsuario: data.idUsuario ?? 0,
          })
        );
        dispatch(setOpenFormDuplicateProjetoState(data.openForm));

        // inserir a rota no arquivo MainRouter.tsx
        navigate("/geo-veles/projetos/duplicate");
      } else {
        dispatch(resetDuplicateProjetoFormState());
        navigate("/geo-veles/projetos");
      }
    },
    [dispatch, navigate]
  );

  return {
    setProjetos,
    setProjetosPaginaInicial,
    setProjetosPagination,
    setOpenCreateProjetoForm,
    updateFiltrosProjeto,
    setCreateProjetoFormNome,
    createProjeto,
    setOpenEditProjetoForm,
    setEditProjetoFormNome,
    setEditProjetoFormAtivo,
    updateProjeto,
    archiveProjeto,
    openProjeto,
    setProjetoAberto,
    setProjetoAction,
    resetProjetoAction,
    setProjetoFiltroAtivo,
    resetProjetoFiltroAtivo,
    addLocalizacaoFilter,
    removeLocalizacaoFilter,
    addPurgeLocalizacaoFilter,
    removePurgeLocalizacaoFilter,
    addListaCEPFilter,
    removeListaCEPFilter,
    addPurgeListaCEPFilter,
    removePurgeListaCEPFilter,
    setGeolocalizacaoFilter,
    setGeolocalizacaoFilterRadius,
    resetGeolocalizacaoFilter,
    addSexoFilter,
    removeSexoFilter,
    setMaxIdadeFilter,
    setMinIdadeFilter,
    resetIdadeFilter,
    setMaxDataNascimentoFilter,
    setMinDataNascimentoFilter,
    resetDataNascimentoFilter,
    setMaxRendaMensalFilter,
    setMinRendaMensalFilter,
    setMaxRendaAnualFilter,
    setMinRendaAnualFilter,
    addClasseSocialFilter,
    removeClasseSocialFilter,
    addEscolaridadeFilter,
    removeEscolaridadeFilter,
    addScoreVelesFilter,
    removeScoreVelesFilter,
    addContatoFilter,
    removeContatoFilter,
    addEstadoCivilFilter,
    removeEstadoCivilFilter,
    addCBOFilter,
    removeCBOFilter,
    addProfissaoFilter,
    removeProfissaoFilter,
    resetFiltros,
    resetProjetoAberto,
    resetRendaMensalFilter,
    resetRendaAnualFilter,
    setProjetoActiveSection,
    setPage,
    setLimit,
    setOpenExportType,
    setCreateExtracaoFormNome,
    setCreateExtracaoFormQuantidade,
    createExtracao,
    resetCreateExtracaoForm,
    resetCreateExtracaoFormQuantidade,
    setProjetoListFiltrosSearchTerm,
    resetProjetoListFiltrosSearchTerm,
    setProjetoListFiltrosInclusaoStart,
    resetProjetoListFiltrosInclusaoStart,
    setProjetoListFiltrosInclusaoEnd,
    resetProjetoListFiltrosInclusaoEnd,
    resetProjetoListFiltros,
    setProjetoListFiltrosAtivo,
    resetProjetoListFiltrosAtivo,
    addListaDeduplicacaoFilter,
    removeListaDeduplicacaoFilter,
    setActiveDetailsSection,
    setProjetoListFiltrosUsuario,
    resetProjetoListFiltrosUsuario,
    setProjetoListFiltrosLoginUsuario,
    resetProjetoListFiltrosLoginUsuario,
    setProjetoListFiltrosCliente,
    resetProjetoListFiltrosCliente,
    verifyTravaConsumo,
    verificarFiltros,
    verifyNumeroExtracao,
    setVerifyAcesso,
    resetRelatorioProjeto,
    setDuplicateProjeto: duplicateProjeto,
    setOpenDuplicateProjetoForm,
    setDuplicateProjetoFormNome,
    addSituacaoCadastralFilter,
    removeSituacaoCadastralFilter,
    addListaCidadesFilter,
    removeListaCidadesFilter,
    addPurgeListaCidadesFilter,
    removePurgeListaCidadesFilter,
    addListaCBOFilter,
    removeListaCBOFilter,
  };
};
